module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://estimation-maisonblanche.omnicasaweb.com"},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Century21MaisonBlanche","short_name":"Century21MaisonBlanche","start_url":"/","background_color":"#ffffff","theme_color":"#bcaf8f","display":"standalone","icon":"/opt/app/project-source/5fcef9122f89dc0013454fd8/source/customer/Century21MaisonBlanche/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"84699a121ab6bd884aeb19f7366b0493"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-N4GNCMD8Y2"],"gtagConfig":{"anonymize_ip":true,"cookie_expires":0},"pluginConfig":{"head":true,"respectDNT":true}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
